import React from 'react';
import { observer } from 'mobx-react-lite';
import { useStores } from '@/contexts/StoreContext';
import { Camera, Download, Linkedin } from 'lucide-react';
import { getCurrentProject, exportSelectionToPNG, exportSelectionToSVG } from '../../utils/projectManager';
import styles from './ExportPanel.module.css';

export const ExportPanel: React.FC = observer(() => {
  const { uiStore } = useStores();
  
  // Handle PNG export
  const handlePNGExport = () => {
    const svgElement = uiStore.canvaSvgElement;
    if (!svgElement) {
      alert('Canvas not available for export');
      return;
    }

    const currentProject = getCurrentProject();
    const fileName = currentProject ? 
      `${currentProject.name.replace(/[^a-z0-9]/gi, '_').toLowerCase()}.png` : 
      undefined;

    try {
      exportSelectionToPNG(svgElement, fileName);
      console.log('PNG export initiated successfully');
    } catch (error) {
      console.error('Failed to export PNG:', error);
      alert('Failed to export PNG. Please try again.');
    }
  };

  // Handle SVG export
  const handleSVGExport = () => {
    const svgElement = uiStore.canvaSvgElement;
    if (!svgElement) {
      alert('Canvas not available for export');
      return;
    }

    const currentProject = getCurrentProject();
    const fileName = currentProject ? 
      `${currentProject.name.replace(/[^a-z0-9]/gi, '_').toLowerCase()}.svg` : 
      undefined;

    try {
      exportSelectionToSVG(svgElement, fileName);
    } catch (error) {
      console.error('Failed to export SVG:', error);
      alert('Failed to export SVG. Please try again.');
    }
  };

  // Handle LinkedIn profile link
  const handleLinkedInClick = () => {
    window.open('https://www.linkedin.com/in/jakub-zwirko/', '_blank');
  };

  return (
    <div className={styles['container']}>
      <div className={styles['actions']}>
        <button
          onClick={handlePNGExport}
          className={styles['exportButton']}
          title="Export canvas as PNG"
        >
          <Camera className={styles['exportIcon']} />
        </button>

        <button
          onClick={handleSVGExport}
          className={styles['exportButton']}
          title="Export canvas as SVG (vector format, includes images)"
        >
          <Download className={styles['exportIcon']} />
        </button>

        <button
          onClick={handleLinkedInClick}
          className={styles['exportButton']}
          title="Visit my LinkedIn profile"
        >
          <Linkedin className={styles['exportIcon']} />
        </button>
      </div>
    </div>
  );
}); 